import * as Sentry from '@sentry/react'

const dsn = process.env.REACT_APP_SENTRY_DSN

const isProduction = process.env.NODE_ENV === 'production'

// в production винаги (ако има DSN), в dev само с REACT_APP_SENTRY_DEV=true
export const sentryEnabled = Boolean(dsn) && (isProduction || process.env.REACT_APP_SENTRY_DEV === 'true')

if (sentryEnabled) {
    Sentry.init({
        dsn,
        environment: isProduction ? (process.env.REACT_APP_SENTRY_ENVIRONMENT || 'production') : 'development',
        release: process.env.REACT_APP_SENTRY_RELEASE,
        sendDefaultPii: false,
        ignoreErrors: [
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications',
            'Non-Error promise rejection captured',
        ],
    })
}

export const setSentryUser = user => {
    if (!sentryEnabled) return

    Sentry.setUser(user ? { id: user.id } : null)
    Sentry.setTag('partner_id', user?.partner_id ?? 'none')
}

export { Sentry }
